import React from 'react';
import _get from 'lodash/get';
import { Box, Typography } from '@material-ui/core';
import { getSeriesIconByType } from '../utils';

export const SeriesHeader = ({ activeSeries, small }) => {
  const SeriesTypeIcon = getSeriesIconByType(activeSeries);

  return SeriesTypeIcon ? (
    <Box display="flex" alignItems="center">
      <Box mr={small ? 1 : 2}>
        <SeriesTypeIcon size={small ? 28 : 40} />
      </Box>
      <Typography variant={small ? 'h6' : 'h4'} color="textPrimary">
        {_get(activeSeries, 'fields.title')}
      </Typography>
    </Box>
  ) : null;
};
